import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 3a1 1 0 0 1 1 1v16a1 1 0 0 1 -2 0v-16a1 1 0 0 1 1 -1","key":"svg-0"}],["path",{"d":"M20 3a1 1 0 0 1 1 1v16a1 1 0 0 1 -2 0v-16a1 1 0 0 1 1 -1","key":"svg-1"}],["path",{"d":"M13 5a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3z","key":"svg-2"}]]

const IconLayoutDistributeVerticalFilled = createReactComponent('filled', 'layout-distribute-vertical-filled', 'LayoutDistributeVerticalFilled', __iconNode);

export default IconLayoutDistributeVerticalFilled;